import { FutureEntriesIndicatorTranslations } from "./future-entries-indicator-pt-br";

export const FUTURE_ENTRIES_INDICATOR_ES_MX: FutureEntriesIndicatorTranslations = {
	futureEntries: "Movimientos futuros de los próximos",
	days: "{{count}} días",
	viewFutureEntries: "Ver Movimientos Futuros",
	futureEntriesTooltip:
		"Importes esperados, como cuentas por cobrar y cargos que vencen pronto o que están pendientes debido a fondos insuficientes.",
};
